import request from "@/utils/request";
import config from "@/utils/config";
import {handleUrlEncode} from "@/utils/urlutil"

/**
 * 后台分页获取版本信息集合
 * @param {Object} params
 */
export function getVersionList(params) {
	let url = config.API_ADMIN + "/Api/V1/AdminVersion/List?";
	url = handleUrlEncode(url,params)
	return request({
		url: url,
		method: "get",
	});
}

/**
 * 后台根据类型获取最新版本信息
 * @param {Object} params
 */
export function getLatestVersionInfo(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVersion/Latest",
		method: "get",
		params,
	});
}

/**
 * 后台根据版本获取兼容版本信息集合
 * @param {Object} params
 */
export function getCompatibleList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVersion/CompatibleList",
		method: "get",
		params,
	});
}

/**
 * 后台添加新版本信息
 * @param {Object} data
 */
export function addVersion(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminVersion/Add",
		method: "post",
		data,
	});
}
